export const config = {
  init: false,
  loop: true,
  autoplay: { delay: 3000 },
  speed: 1000,
  modules: []
};